import { Paper } from "@material-ui/core";
import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { findUserAPI } from "./module/action";
import "./style.scss";
import UserList from "./UserList";

export default function UserManagement() {
  const dispatch = useDispatch();
  const handleChange = (e) => {
    e.preventDefault();
    const { value } = e.target;
    dispatch(findUserAPI(value));
  };
  return (
    <Paper className="userAddAdmin">
      <div className="container-fluid">
        <div className="rows">
          <div className=" item">
            <Link to="/admin/adduser" className="addUser__link">
              <button className="btn" style={{ margin: "10px 5px" }}>
                ADD USER
              </button>
            </Link>
          </div>
          <div className="item">
            <form className="form-inline">
              <div className="form-group">
                <input
                  id="add"
                  type="search"
                  placeholder="Search by name"
                  className="form-control"
                  onChange={handleChange}
                  name="search"
                ></input>
                <i class="fas fa-search"></i>
              </div>
            </form>
          </div>
        </div>
      </div>
      <UserList />
    </Paper>
  );
}
